<div class="exclude_modal">
    <div class="header">
        <h3>Exclude Lead Source</h3>
        <span (click)="dialogRef.close()"><mat-icon>close</mat-icon></span>
    </div>
    <div>
        <form [formGroup]="leadSourceForm">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Select Lead Source</mat-label>
                        <mat-select  multiple formControlName="leadSources">
                          <mat-option *ngFor="let item of data?.leadSource" [value]="item?.source">{{item?.title}} - {{item?.source}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="leadSourceForm.controls['leadSources'].touched && leadSourceForm.controls['leadSources'].hasError('required')">
                            This is a required field.
                        </mat-error>
                      </mat-form-field>
                </div>
              <div class="btnprt">
                <button mat-raised-button color="warn" (click)="dialogRef.close()">Close</button>
                <button mat-raised-button color="primary" (click)="excludeLead()">Exclude Lead</button>
              </div>
        </form>
    </div>
</div>
